export enum CategoryHelpCenter {
  GROWTH = 'growth',
  ONBOARDING = 'onboarding',
  OPTIMIZATION = 'optimization',
  PAYMENTS = 'payments',
}
